import { render, staticRenderFns } from "./signup_submit_button.vue?vue&type=template&id=2330a94d"
import script from "./signup_submit_button.vue?vue&type=script&lang=js"
export * from "./signup_submit_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports